import { useState, useCallback, useRef } from 'react'
import { useRouter } from 'next/router'

import { withUserContext, withUIContext } from 'context'

import { FormContainer, Input, ButtonSimple, Icon, Text } from 'components/common'
import { Form, Input as BaseInput } from 'antd'

import Style from './style'

const ResetPassword = ({ resetPassword, closePopup }) => {

    const router = useRouter()

    const form = useRef()

    const uppercaseRef = useRef()
    const lowercaseRef = useRef()
    const numbersRef = useRef()
    const eightsRef = useRef()

    const [thankYou, setThankYou] = useState(false)

    const onChange = useCallback((newVal) => {
        if (newVal['password'] != undefined) {
            const password = newVal['password']

            const containsUppercase = /[A-Z]/
            const containsLowercase = /[a-z]/
            const containsNumbers = /[0-9]/

            if (containsUppercase.test(password)) {
                uppercaseRef.current.classList.add('green')
                uppercaseRef.current.classList.remove('black')
            } else {
                uppercaseRef.current.classList.add('black')
                uppercaseRef.current.classList.remove('green')
            }

            if (containsLowercase.test(password)) {
                lowercaseRef.current.classList.add('green')
                lowercaseRef.current.classList.remove('black')
            } else {
                lowercaseRef.current.classList.add('black')
                lowercaseRef.current.classList.remove('green')
            }

            if (containsNumbers.test(password)) {
                numbersRef.current.classList.add('green')
                numbersRef.current.classList.remove('black')
            } else {
                numbersRef.current.classList.add('black')
                numbersRef.current.classList.remove('green')
            }

            if (password.length >= 8) {
                eightsRef.current.classList.add('green')
                eightsRef.current.classList.remove('black')
            } else {
                eightsRef.current.classList.add('black')
                eightsRef.current.classList.remove('green')
            }
        }
    }, [])

    const handleResetPassword = useCallback((values) => {
        return resetPassword(values).then(() => {
            setThankYou(true)
        })
    }, [])

    return (
        <Style className={`parent-cont flexBoxColumn alignMiddle`}>
            <FormContainer
                ref={form}
                className='reset'
                initialValues={{
                    email: router.query.email,
                    token: router.query.token,
                }}
                onChange={onChange}
                onFinish={handleResetPassword}>
                <div className='block'>
                    <Icon className='op-close cursorPointer' onClick={closePopup} />
                    {thankYou ? (
                        <>
                            <Text tag={'h4'} className={'h4 PopSemi title'} text={'Thank You'} />
                            <Text tag={'p'} className={'const14 PopReg grey subtitle'} text={'Your password has been reset!'} />
                            <ButtonSimple className='done-btn' text='Done' onClick={closePopup} />
                        </>
                    ) : (
                        <>
                            <Text tag={'h4'} className={'h4 PopSemi title'} text={'Reset Password'} />
                            <Input
                                labelOptions={{ noStyle: true }}
                                name={'email'}
                                inputOptions={{ type: 'hidden' }}
                            />
                            <Input
                                labelOptions={{ noStyle: true }}
                                name={'token'}
                                inputOptions={{ type: 'hidden' }}
                            />
                            <Input
                                type={'password'}
                                name={'password'}
                                placeholder={'New password'}
                                errorKey={'New password'}
                                labelOptions={{
                                    hasFeedback: true
                                }}
                                rules={[
                                    {
                                        pattern: new RegExp(/((?=.*\d)|(?=.*\W+))(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$/),
                                        message: '',
                                    },
                                ]}
                            />
                            <Form.Item
                                name={'password_confirmation'}
                                dependencies={['password']}
                                hasFeedback
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please confirm your password!',
                                    },
                                    ({ getFieldValue }) => ({
                                        validator(_, value) {
                                            if (!value || getFieldValue('password') === value) {
                                                return Promise.resolve();
                                            }

                                            return Promise.reject(new Error('The two passwords that you entered do not match!'));
                                        },
                                    }),
                                ]}
                            >
                                <BaseInput.Password className="input-text" placeholder={'Confirm new password'} />
                            </Form.Item>
                            <div className='halfInputs check flexBox'>
                                <Text ref={uppercaseRef} className={'black PopSemi'} tag={'span'}>
                                    A <br />
                                    uppercase
                                </Text>
                                <Text ref={lowercaseRef} className={'black PopSemi'} tag={'span'}>
                                    a <br />
                                    lowercase
                                </Text>
                                <Text ref={numbersRef} className={'black PopSemi'} tag={'span'}>
                                    123 <br />
                                    number
                                </Text>
                                <Text ref={eightsRef} className={'black PopSemi'} tag={'span'}>
                                    8+ <br />
                                    characters
                                </Text>
                            </div>
                            <ButtonSimple submit className='done-btn' text='Done' />
                        </>
                    )}
                </div>
            </FormContainer>
        </Style>
    )
}

export default withUIContext(withUserContext(ResetPassword, ['resetPassword']), ['closePopup'])
